import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from "./services/auth/auth.guard";
import { IoGlobals } from "./ioglobals";
import { MAT_DATE_LOCALE, MAT_DATE_FORMATS, MatSnackBarModule } from '@angular/material';
import { AppDateAdapter, APP_DATE_FORMATS } from "./services/mask/datepicker";
import { DateAdapter } from '@angular/material/core';
import { AppComponent } from './app.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { PriceViewComponent } from './price-view/price-view.component';
import { ViewFileMobileComponent } from './view-file-mobile/view-file-mobile.component';
import { SanitizeHtmlServiceModule } from './services/sanitizehtml';
import { SanitizeSrcServiceModule } from './services/sanitizesrc';
import { DatePipe } from '@angular/common';

export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient);
}
const appRoutes: Routes = [

    { path: 'login', redirectTo: 'browsers' },
    { path: 'view-file', component: ViewFileMobileComponent },
    { path: 'browsers', loadChildren: './browsers/browsers.module#BrowsersModule' },
    { path: '', loadChildren: './layout/layout.module#LayoutModule', canActivate: [AuthGuard] },

    { path: 'price-view/:keyconfig', component: PriceViewComponent },
    { path: 'price-view/:keyconfig/:language', component: PriceViewComponent },
    { path: 'not-found', component: NotFoundComponent },
    { path: '**', redirectTo: 'not-found' },
];

@NgModule({
    declarations: [
        AppComponent,
        NotFoundComponent,
        PriceViewComponent,
        ViewFileMobileComponent
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes),

        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),

        BrowserAnimationsModule,
        SanitizeHtmlServiceModule,
        SanitizeSrcServiceModule,
        MatSnackBarModule
    ],
    providers: [
        IoGlobals,
        {
            provide: DateAdapter, useClass: AppDateAdapter
        },
        {
            provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS
        },
        { provide: MAT_DATE_LOCALE, useValue: 'vi-GB' },
        AuthGuard,
        DatePipe
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {

}
